interface GetLibraryItemLinkParams {
  libraryItemId: string; // library item id
  itemType: string; // item type
  slug: string; // library item slug if available
  publisherName?: string; // pass publisher user name
  lang?: string; // pass language from url if available.
}

/**
 * Get library item link
 */
const getLibraryItemLink = ({
  libraryItemId,
  itemType,
  slug,
  publisherName,
  lang
}: GetLibraryItemLinkParams) => {
  const gmLangPath = lang ? `/${lang}` : '';

  if (itemType === 'COURSES') {
    return `/meditation-courses/${slug}`;
  }

  return slug && publisherName
    ? `/${publisherName}/guided-meditations/${slug}`
    : `/guided-meditations/${libraryItemId}${gmLangPath}`;
};

export default getLibraryItemLink;
